export default __webpack_public_path__ + "static/media/community_default.36e7bd73.svg";